import { Base } from '@studiometa/js-toolkit';

/**
 * Menu component
 */
export default class Submenu extends Base {
  isOpen = false;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Submenu',
    refs: ['close'],
  };

  /**
   *
   */
  onCloseClick() {
    this.close();
  }

  /**
   *
   */
  open() {
    this.$el.classList.remove('max-s:pointer-events-none', 'max-s:translate-x-full');
    this.$el.classList.add('pointer-events-auto');
    this.$parent.$refs.wrapper.classList.add('pointer-events-none');
  }

  /**
   *
   */
  close() {
    this.$el.classList.add('max-s:pointer-events-none', 'max-s:translate-x-full');
    this.$el.classList.remove('pointer-events-auto');
    this.$parent.$refs.wrapper.classList.remove('pointer-events-none');
  }
}
